<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { dateDeDE, dateEnGB, deDE, enGB } from 'naive-ui'

// Internationalization
const { locale } = useI18n()
const naiveLangConfig = computed(() => {
  if (locale.value === 'de') {
    return { locale: deDE, dateLocale: dateDeDE }
  }
  return { locale: enGB, dateLocale: dateEnGB }
})

const i18nHead = useLocaleHead({
  lang: true,
  seo: true,
  key: 'id',
})
useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])],
})
</script>

<template>
  <naive-config :locale="naiveLangConfig.locale" :date-locale="naiveLangConfig.dateLocale">
    <NNotificationProvider placement="top" :max="3">
      <naive-notification />
      <slot />
    </NNotificationProvider>
    <VueQueryDevtools />
    <TheCookieConsent />
  </naive-config>
</template>

<style>
body { @apply text-base font-kiso }

/* Text styles */
h1 { @apply text-xl xl:text-2xl leading-5 font-bold tracking-wide }
h2 { @apply text-xl font-semibold tracking-wide }
h3 { @apply text-lg font-semibold }
h4 { @apply text-base font-semibold }

/* Notification style override to properly center icon and text */
.n-notification-container .n-notification { @apply flex items-start gap-2 py-3 }
.n-notification-container .n-notification .n-notification__avatar { @apply relative top-0 left-0 }
.n-notification-container .n-notification.n-notification--show-avatar .n-notification-main { @apply ml-0 py-0 }
.n-notification-main__header { @apply !font-semibold }
.n-notification-container .n-notification .n-notification-main .n-notification-main__content { @apply mt-1 }

/* Icon Styles */
.nuxt-icon {
  width: 100% !important;
  height: 100% !important;
  margin-bottom: 0 !important;
}

.icon {
  overflow: hidden;
}
</style>
